module.exports = __webpack_public_path__ + "img/27_26.656b4885.png";